module.exports = __webpack_public_path__ + "static/pink-rectangle-3decbdf9943ec4bbaf0c1ce3a555bba4.svg";